import React, { useState, useEffect, ChangeEvent, FormEvent } from "react";
import { Modal, Button } from "react-bootstrap";

// 1. Define the shape of your form data
interface SubscriptionFormData {
    st_name: string;
    st_dec: string;
}

// 2. Define the Props interface
interface AddSubscriptionModalProps {
    show: boolean;
    onHide: () => void;
    editData?: SubscriptionFormData | null; // Optional data for editing
}

const AddSubscriptionModal: React.FC<AddSubscriptionModalProps> = ({
    show,
    onHide,
    editData
}) => {
    // Initialize state with default empty values
    const [formData, setFormData] = useState<SubscriptionFormData>({
        st_name: "",
        st_dec: "",
    });

    const [loading, setLoading] = useState<boolean>(false);

    // 3. Handle pre-filling data when editData changes
    useEffect(() => {
        if (editData) {
            setFormData({
                st_name: editData.st_name || "",
                st_dec: editData.st_dec || "",
            });
        } else {
            // Reset form if opening for a fresh "Add"
            setFormData({ st_name: "", st_dec: "" });
        }
    }, [editData, show]);

    // Generic change handler
    const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setLoading(true);
        // Add your submission logic here (e.g., API call)
        console.log("Submitted Data:", formData);

        // Simulate API delay
        setTimeout(() => setLoading(false), 1000);
    };

    return (
        <Modal className="s_modal" show={show} onHide={onHide} backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title className="h5">{editData ? "Edit Subscription" : "Create Subscription"}</Modal.Title>
            </Modal.Header>

            <form noValidate onSubmit={handleSubmit}>
                <Modal.Body>
                    <div className="row g-3">
                        <div className="col-lg-12">
                            <div className="row g-3">
                                <div className="col-lg-7 border-end">
                                    <div className="pe-2">
                                        <div className="row g-3">
                                            <div className="col-lg-12">
                                                <div className="form-group mb-0">
                                                    <label>Select User</label>
                                                    <select className="form-select">

                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="form-group mb-0">
                                                    <label>Select Plan</label>
                                                    <select className="form-select">

                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="form-group mb-0">
                                                    <label>Start Date</label>
                                                    <input type="text" className="form-control"></input>
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="form-group mb-0">
                                                    <label>End Date</label>
                                                    <input type="text" className="form-control"></input>
                                                </div>
                                            </div>
                                            <div className="col-lg-12">
                                                <h6>Shipping & Billing Detail</h6>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="form-group mb-0">
                                                    <label>Address</label>
                                                    <input type="text" className="form-control"></input>
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="form-group mb-0">
                                                    <label>Country</label>
                                                    <input type="text" className="form-control"></input>
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="form-group mb-0">
                                                    <label>State</label>
                                                    <input type="text" className="form-control"></input>
                                                </div>
                                            </div>
                                             <div className="col-lg-6">
                                                <div className="form-group mb-0">
                                                    <label>City</label>
                                                    <input type="text" className="form-control"></input>
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="form-group mb-0">
                                                    <label>Postcode</label>
                                                    <input type="text" className="form-control"></input>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-5">
                                    <div className="ps-2">
                                        <div className="row g-3">
                                             <div className="col-lg-12">
                                                <div className="form-group mb-0">
                                                    <label>Business Name</label>
                                                    <input type="text" className="form-control"></input>
                                                </div>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="form-group mb-0">
                                                    <label>GSTIN Number</label>
                                                    <input type="text" className="form-control"></input>
                                                </div>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="form-group mb-0">
                                                    <label>Note (optional)</label>
                                                    <textarea className="form-control"></textarea>
                                                </div>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="card">
                                                    <div className="card-header">
                                                        <h6>Payments</h6>
                                                    </div>
                                                    <div className="card-body py-2">
                                                        <ul className="payment-summary">
                                                            <li>
                                                                <span>Taxable Amount</span>
                                                                <span>₹578.00</span>
                                                            </li>
                                                              <li>
                                                                <span><a href="#">Add Discount</a></span>
                                                                <span>₹0.00</span>
                                                            </li>
                                                              <li>
                                                                <span>IGST 18% (Included)</span>
                                                                <span>₹578.00</span>
                                                            </li>
                                                              <li>
                                                                <span className="fw-bold">Total</span>
                                                                <span className="fw-bold">₹578.00</span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={onHide} disabled={loading}>
                        Cancel
                    </Button>

                    <Button type="submit" variant="primary" disabled={loading}>
                        Save
                    </Button>
                </Modal.Footer>
            </form>
        </Modal>
    );
};

export default AddSubscriptionModal;